import { createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'

import { BaseHttpService } from 'services/api/BaseHttpService'

import { languagesType, languagesWithIcons, shortLanguages } from 'shared/locale'
import { ThunkAction } from 'shared/models/thunk'

import { actions as localeActions } from 'features/locale'

export const CHANGE_LANG = '@userSettings/CHANGE_LANG'

export const changeLang = createAsyncThunk<
  { lang: languagesType; direction: 'ltr' | 'rtl' },
  languagesType,
  ThunkAction
>(CHANGE_LANG, async (lang, { dispatch }) => {
  const { locale } = await import(`shared/locale/${lang}/index`)
  const html = document.querySelector('html')

  const direction = languagesWithIcons[lang].isArabic ? 'rtl' : 'ltr'

  if (html) {
    html.lang = shortLanguages[lang]
    html.dir = languagesWithIcons[lang].isArabic ? 'rtl' : 'ltr'
  }

  dayjs.locale(shortLanguages[lang])
  dispatch(localeActions.changeLang(locale))
  BaseHttpService.setLang(shortLanguages[lang])

  return {
    lang,
    direction,
  }
})
